// extracted by mini-css-extract-plugin
export default {"numericCalcWrapper":"numericCalcPreference_numericCalcWrapper__g320H"};